// extracted by mini-css-extract-plugin
export default {"wrapper":"Tour_wrapper__idNbr"};